/**
 * Date: 2020-08-13 23:01:47
 * description:
 *  @author zhizhan
 * Copyright (c) 2019, YUNXI. All rights reserved.
 * YUNXI PROPRIETARY/CONFIDENTIAL. Use is subject to license terms.
 */

import React, { Component } from "react";
import Basics from "../Basics";
import { cloneDeep, get, set } from "../../../utils";
import ColorPicker from "./ColorPicker";
import { YxComponent } from "../../YxComponent";

// @Connection(defaul)
class YxColorPicker extends YxComponent {
  productionHtml() {
    let props = { ...this.props };
    let classParam = {
      yx_yxColorPicker_: "styleParam.type",
      yx_yxColorPicker_width_: "styleParam.width",
      yx_yxColorPicker_size_: "styleParam.size",
    };
    if (props.form) {
      props.children = <ColorPicker form={this.props.form} />;
      set(props, "getFieldDecoratorParam.valuePropName", "value");
      set(props, "getFieldDecoratorParam.validateTrigger", "onChange");
      set(props, "getFieldDecoratorParam.trigger", "onChange");
      set(
        props,
        "inputParam.className",
        this.styleParamClassName(props, classParam)
      );
      let html = Basics.html(props);
      return html;
    } else {
      set(props, "className", this.styleParamClassName(props, classParam));
      return <ColorPicker {...props} />;
    }
  }
  render() {
    return this.productionHtml();
  }
}
export default YxColorPicker;



// WEBPACK FOOTER //
// ./src/yx-widget/component/YxInput/ColorPicker/YxColorPicker.js